import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "top-bar" }
const _hoisted_2 = { style: {"width":"10%"} }
const _hoisted_3 = { style: {"color":"white","font-size":"20px","font-weight":"bold"} }
const _hoisted_4 = { style: {"width":"20%"} }
const _hoisted_5 = { style: {"display":"flex","align-items":"center","float":"right","margin-top":"5px","color":"white","font-size":"15px","font-weight":"bold"} }
const _hoisted_6 = { style: {"margin-right":"8px"} }

import { watch } from "vue";
import { useAuth } from "@/composables/useAuth";
import { NIcon, NButton } from "naive-ui";
import { LogOutOutline as LogOutIcon } from "@vicons/ionicons5";

export default /*@__PURE__*/_defineComponent({
  __name: 'TopBar',
  setup(__props) {

const { loggedInUserId, handleLogout } = useAuth();

watch(loggedInUserId, () => {
    console.log(`TopBar : ${loggedInUserId.value}`);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title")), 1)
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"width":"70%"} }, null, -1)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(loggedInUserId)) + " 님", 1),
        _createVNode(_unref(NButton), {
          quaternary: "",
          style: {"color":"white"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(handleLogout)()))
        }, {
          icon: _withCtx(() => [
            _createVNode(_unref(NIcon), { size: "25" }, {
              default: _withCtx(() => [
                _createVNode(_unref(LogOutIcon))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})